import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import useClickOutside from "../../hooks/useClickOutside";
import SvgIcon from "../SvgIcon";

const DropdownCheckboxGroup = ({
  label,
  name,
  values = [],
  checkboxes = [],
  onChange,
  checkboxClass = "",
  videoStyle = false,
}) => {
  const { t } = useTranslation("common");
  const [opened, setOpened] = useState(false);
  const dropdownRef = useRef(null);
  useClickOutside(dropdownRef, () => setOpened(false), opened);
  return (
    <div>
      {label && (
        <label className="label" htmlFor={name}>
          {label}
        </label>
      )}
      <details ref={dropdownRef} role="list" open>
        <summary
          onClick={(e) => {
            e.preventDefault();
            setOpened(!opened);
          }}
        >
          <p>
            {values.length > 0
              ? t("checkboxGroupDropdown.selectedCount", {
                  count: values.length,
                })
              : t("checkboxGroupDropdown.select")}
          </p>
          <SvgIcon
            src={opened ? "/img/svg/angle-up.svg" : "/img/svg/angle-down.svg"}
          />
        </summary>
        <ul role="listbox" className={opened ? "opened" : ""}>
          {checkboxes.map((val, i) => {
            const value = typeof val === "object" ? val.value : val;
            const label = typeof val === "object" ? val.title : val;
            return (
              <li key={`${i}${value}`}>
                <div>
                  <label className="flex items-center gap-2">
                    <input
                      name={name}
                      type="checkbox"
                      value={value}
                      className={`checkbox ${checkboxClass}`}
                      onChange={onChange}
                      checked={values.includes(value)}
                    />
                    <span aria-label={value}>{label}</span>
                  </label>
                </div>
              </li>
            );
          })}
        </ul>
      </details>
      <div
        className={
          videoStyle ? "checkbox-group-list checkbox-group" : "checkbox-group"
        }
      ></div>
    </div>
  );
};

export default DropdownCheckboxGroup;
